<template>
    <div class="modal-out">
        <div class="modal">
            <div class="modal-header">
                <div class="title">修改</div>
                <button type="button" class="btn-close" @click="closeSelf">X</button>
            </div>
            <div class="modal-body">
                <el-form :model="editForm" :rules="rules" ref="editForm">
                  <el-row>
                    <el-col :span="12" class="item">
                      <el-form-item label="机构" prop="institutionCode">
                        <el-select
                            v-model="editForm.institutionCode"
                            style="width:100%"
                            placeholder="请选择机构">
                          <el-option
                              v-for="item in arr_ins"
                              :key="item.institutionCode"
                              :label="item.userName"
                              :value="item.institutionCode">
                          </el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" class="item">
                      <el-form-item label="来访人姓名" required prop="visitorName">
                        <el-input v-model="editForm.visitorName" placeholder="请输入来访人姓名"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" class="item">
                      <el-form-item label="来访人手机" required prop="visitorPhone">
                        <el-input v-model="editForm.visitorPhone" maxlength="11" placeholder="请输入来访人手机"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24" class="item">
                      <el-form-item label="描述" required prop="remarks">
                        <el-input v-model="editForm.remarks" type="textarea" placeholder="请输入描述"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>

            </div>
            <div class="modal-footer">
                <el-button :loading="loading" type="primary" @click="confirm('editForm')">修改</el-button>
            </div>
        </div>
    </div>
</template>

<script>

    import {timeStr} from "@/common/times";
    import {hex_md5} from "@/common/Base64MD5";
    import {getStaffCode} from "@/utils/auth";

    export default {
        name: 'Edit',
      props:['arr_ins'],
        data() {
            return {
                loading: false,

              editForm:{
                timeStr:timeStr,
                sign:'',
                staffCode:getStaffCode(),
                institutionCode:'',
                receptionRecordCode:'',
                visitorName:'',
                visitorPhone:'',
                remarks:'',
              },

                rules:{
                  visitorName:[
                    { required: true, message: '请输入来访人姓名', trigger: 'blur' },
                  ],
                  visitorPhone:[
                    { required: true, message: '请输入来访人手机', trigger: 'blur' },
                    {
                      pattern: /^1[3456789]\d{9}$/,
                      message: '请输入正确的手机号', trigger: 'blur'
                    }
                  ],
                  remarks:[
                    { required: true, message: '请输入描述', trigger: 'blur' },
                  ],
                  institutionCode:[
                    { required: true, message: '请选择机构', trigger: 'blur' },
                  ],
                }

            }
        },

        methods: {

            init(row){

                this.editForm.visitorName = row.visitorName;
                this.editForm.visitorPhone = row.visitorPhone;
                this.editForm.remarks = row.remarks;
                this.editForm.receptionRecordCode = row.receptionRecordCode;
                this.editForm.institutionCode = row.institutionCode;
            },
            closeSelf() {
                this.$emit("closeEdit");
            },

            confirm(editForm){
                this.$refs[editForm].validate((valid) => {
                    if(valid){
                        this.addSubmit();
                    }else {
                        console.log('error submit!!');
                        return false;
                    }
                })


            },

            addSubmit(){

                if(this.loading){
                    return;
                }else{
                    this.loading = true;
                }

                this.editForm.sign = hex_md5("timeStr=" + timeStr + "&key="+this.$signKey);

                this.$axios({
                    method: 'post',
                    url: this.$shopUrl+"ReceptionRecord/GovEditIns",
                    data: this.editForm
                }).then(
                    (response) => {
                        this.loading = false;
                        if (response.data.error == 0) {
                            this.$emit("closeEdit");
                            this.$emit("getList");
                        }else if(response.data.error == 1){
                            this.$message({type: 'info', message: response.data.message});
                        }
                    }
                )
            },

        }
    }


</script>


<style lang="scss" scoped>

</style>
